<template>
    <div>
        <section class="section" style="background-color: #233dff;">
            <div class="container">
                <div class="row align-items-center">
                    <div class="col-lg-12 col-12">
                        <div class="mt-4 mt-md-auto text-center">
                            <img src="awan/images/riot-logo.png" alt="potensi-pasar-penjualan-produk-digital"
                                style="width: 150px;" data-aos="fade-down" class="img-fluid mx-auto d-block">
                            <h1 class="text-light font-weight-bold mt-4 hero-title" data-aos="fade-up"
                                style="font-family: 'Baloo Paaji'; font-size: 40px;">Halo SPARTAN RIOT BALI,</h1>
                            <p class="font-size-20 text-light" data-aos="fade-up">Happy Anniversary untuk RIOT Bali dan RIOT Indonesia yang ke 8 Tahun</p>
                        </div>
                    </div>
                </div>

                <div class="row align-items-center">
                    <div class="col-lg-12 col-12">
                        <div class="mt-4 mt-md-auto text-center">
                            <p class="font-size-16 text-light" data-aos="fade-up">Download Aplikasi Awan Disini:</p>
                            <div class="button-items" data-aos="fade-up">
                                <a href="https://play.google.com/store/apps/details?id=com.awan" target="blank"
                                    data-aos="fade-left">
                                    <img src="awan/images/google-play-store-badge.svg" alt="Google Play">
                                </a>
                                <a href="https://apps.apple.com/id/app/awan-ppob-pulsa-tagihan/id6480331409"
                                    target="blank" data-aos="fade-left">
                                    <img src="awan/images/apple-store-badge.svg" alt="App">
                                </a>
                            </div>
                            <br>
                            <img src="awan/images/riot-footer-2.png" alt="App" style="width: 380px;" data-aos="fade-up">
                            <br>
                            <br>
                            <p class="font-size-20 text-light" data-aos="fade-up">5 Langkah mendapatkan Saldo Gratis
                                dari Awanbisnis:</p>
                            <ul style="list-style-type: none; padding: 0; margin: 0; display: flex; flex-direction: column; align-items: center;"  class="font-size-16 text-light" data-aos="fade-up">
                                <li  style="list-style-type: none; padding-left: 35px; background: url('awan/images/checklist.png') no-repeat left center; background-size: 30px; margin: 10px 0;">Download Aplikasi Awanbisnis</li>
                                <li  style="list-style-type: none; padding-left: 35px; background: url('awan/images/checklist.png') no-repeat left center; background-size: 30px; margin: 10px 0;">Review di Playstore dan Appstore</li>
                                <li  style="list-style-type: none; padding-left: 35px; background: url('awan/images/checklist.png') no-repeat left center; background-size: 30px; margin: 10px 0;">Berikan Bintang 5</li>
                                <li  style="list-style-type: none; padding-left: 35px; background: url('awan/images/checklist.png') no-repeat left center; background-size: 30px; margin: 10px 0;">Follow IG <a href="https://www.instagram.com/awanbisnis/" style="color: yellow; text-decoration: none;">@awanbisnis</a></li>
                                <li  style="list-style-type: none; padding-left: 35px; background: url('awan/images/checklist.png') no-repeat left center; background-size: 30px; margin: 10px 0;">Share info tentang Awanbisnis ke orang-orang yang kamu kenal</li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div class="row align-items-center mt-5">
                    <div class="col-12 col-lg-4">
                        <div data-aos="fade-up">
                            <img src="awan/images/riot-1.png" alt="potensi-pasar-penjualan-produk-digital"
                                style="width: 300px;" data-aos="fade-up" class="img-fluid mx-auto d-block">
                            <p style="height: 100px;" class="font-size-16 mt-3 text-light text-center"
                                data-aos="fade-up">Buka Google Playstore dan Search atau ketik awanbisnis di kolom
                                pencarian</p>
                        </div>
                    </div>
                    <div class="col-12 col-lg-4">
                        <div data-aos="fade-up">
                            <img src="awan/images/riot-2.png" alt="potensi-pasar-penjualan-produk-digital"
                                style="width: 300px;" data-aos="fade-up" class="img-fluid mx-auto d-block">
                            <p style="height: 100px;" class="font-size-16 mt-3 text-light text-center"
                                data-aos="fade-up">Pilih Aplikasi Awan - PPOB Pulsa & Tagihan, klik Instal</p>
                        </div>
                    </div>
                    <div class="col-12 col-lg-4">
                        <div data-aos="fade-up">
                            <img src="awan/images/riot-3.png" alt="potensi-pasar-penjualan-produk-digital"
                                style="width: 300px;" data-aos="fade-up" class="img-fluid mx-auto d-block">
                            <p style="height: 100px;" class="font-size-16 mt-3 text-light text-center"
                                data-aos="fade-up">Klik Masuk/Daftar</p>
                        </div>
                    </div>
                    <div class="col-12 col-lg-4">
                        <div data-aos="fade-up">
                            <img src="awan/images/riot-4.png" alt="potensi-pasar-penjualan-produk-digital"
                                style="width: 300px;" data-aos="fade-up" class="img-fluid mx-auto d-block">
                            <p style="height: 100px;" class="font-size-16 mt-3 text-light text-center"
                                data-aos="fade-up">Masukkan No Hp kemudian Klik Tombol Lanjutkan</p>
                        </div>
                    </div>
                    <div class="col-12 col-lg-4">
                        <div data-aos="fade-up">
                            <img src="awan/images/riot-5.png" alt="potensi-pasar-penjualan-produk-digital"
                                style="width: 300px;" data-aos="fade-up" class="img-fluid mx-auto d-block">
                            <p style="height: 100px;" class="font-size-16 mt-3 text-light text-center d-none d-xl-block"
                                data-aos="fade-up">Klik Tombol Ya, Daftarkan</p>
                            <p style="height: 180px;"
                                class="font-size-16 mt-3 text-light text-center d-md-block d-lg-none "
                                data-aos="fade-up">Klik Tombol Ya, Daftarkan</p>
                        </div>
                    </div>
                    <div class="col-12 col-lg-4">
                        <div data-aos="fade-up">
                            <img src="awan/images/riot-6.png" alt="potensi-pasar-penjualan-produk-digital"
                                style="width: 300px;" data-aos="fade-up" class="img-fluid mx-auto d-block">
                            <p style="height: 100px;" class="font-size-16 mt-3 text-light text-center d-none d-xl-block"
                                data-aos="fade-up">Masukkan Kode OTP yang dikirimkan oleh sistem Awan ke No Hp Kamu.
                                Pastikan Hp yang digunakan aktif dan bisa menerima SMS</p>
                            <p style="height: 180px;"
                                class="font-size-16 mt-3 text-light text-center d-md-block d-lg-none"
                                data-aos="fade-up">Masukkan Kode OTP yang dikirimkan oleh sistem Awan ke No Hp Kamu.
                                Pastikan Hp yang digunakan aktif dan bisa menerima SMS</p>
                        </div>
                    </div>
                    <div class="col-12 col-lg-4">
                        <div data-aos="fade-up">
                            <img src="awan/images/riot-7-2.png" alt="potensi-pasar-penjualan-produk-digital"
                                style="width: 300px;" data-aos="fade-up" class="img-fluid mx-auto d-block">
                            <p style="height: 100px;" class="font-size-16 mt-3 text-light text-center d-none d-xl-block"
                                data-aos="fade-up">Lengkapi data data yang diperlukan dan masukkan KODE VOUCHER yang
                                kamu dapatkan pada kolom Refferall</p>
                            <p style="height: 300px;"
                                class="font-size-16 mt-3 text-light text-center d-md-block d-lg-none"
                                data-aos="fade-up">Lengkapi data data yang diperlukan dan masukkan KODE VOUCHER yang
                                kamu dapatkan pada kolom Refferall</p>
                        </div>
                    </div>
                    <div class="col-12 col-lg-4">
                        <div data-aos="fade-up">
                            <img src="awan/images/riot-8.png" alt="potensi-pasar-penjualan-produk-digital"
                                style="width: 300px;" data-aos="fade-up" class="img-fluid mx-auto d-block">
                            <p style="height: 100px;" class="font-size-16 mt-3 text-light text-center d-none d-xl-block"
                                data-aos="fade-up">Untuk pengisian alamat, cukup ketikkan nama desa/kelurahan di kolom
                                pencarian, maka nanti sistem akan otomatis memberikan beberapa alamat yang bisa kamu
                                sesuaikan dengan alamat kamu</p>
                            <p style="height: 300px;"
                                class="font-size-16 mt-3 text-light text-center d-md-block d-lg-none"
                                data-aos="fade-up">Untuk pengisian alamat, cukup ketikkan nama desa/kelurahan di kolom
                                pencarian, maka nanti sistem akan otomatis memberikan beberapa alamat yang bisa kamu
                                sesuaikan dengan alamat kamu</p>
                        </div>
                    </div>
                    <div class="col-12 col-lg-4">
                        <div data-aos="fade-up">
                            <img src="awan/images/riot-9.png" alt="potensi-pasar-penjualan-produk-digital"
                                style="width: 300px;" data-aos="fade-up" class="img-fluid mx-auto d-block">
                            <p style="height: 100px;" class="font-size-16 mt-3 text-light text-center"
                                data-aos="fade-up">Buat Password dan pastikan syarat-syarat Passwordnya sudah sesuai</p>
                        </div>
                    </div>
                    <div class="col-12 col-lg-4">
                        <div data-aos="fade-up">
                            <img src="awan/images/riot-10.png" alt="potensi-pasar-penjualan-produk-digital"
                                style="width: 300px;" data-aos="fade-up" class="img-fluid mx-auto d-block">
                            <p style="height: 100px;" class="font-size-16 mt-3 text-light text-center"
                                data-aos="fade-up">Buat PIN Transaksi dengan kombinasi 4 Angka untuk menjaga keamanan
                                transaksimu</p>
                        </div>
                    </div>
                    <div class="col-12 col-lg-4">
                        <div data-aos="fade-up">
                            <img src="awan/images/riot-11.png" alt="potensi-pasar-penjualan-produk-digital"
                                style="width: 300px;" data-aos="fade-up" class="img-fluid mx-auto d-block">
                            <p style="height: 100px;" class="font-size-16 mt-3 text-light text-center"
                                data-aos="fade-up">Masukkan sekali lagi PIN yang telah kamu bikin di langkah sebelumnya
                            </p>
                        </div>
                    </div>
                    <div class="col-12 col-lg-4">
                        <div data-aos="fade-up">
                            <img src="awan/images/riot-12.png" alt="potensi-pasar-penjualan-produk-digital"
                                style="width: 300px;" data-aos="fade-up" class="img-fluid mx-auto d-block">
                            <p style="height: 100px;" class="font-size-16 mt-3 text-light text-center"
                                data-aos="fade-up">Kamu berhasil! lakukan verifikasi email untuk melengkapi data kamu
                            </p>
                        </div>
                    </div>
                    <div class="col-12 col-lg-4">
                        <div data-aos="fade-up">
                            <img src="awan/images/riot-13.png" alt="potensi-pasar-penjualan-produk-digital"
                                style="width: 300px;" data-aos="fade-up" class="img-fluid mx-auto d-block">
                            <p style="height: 100px;" class="font-size-16 mt-3 text-light text-center"
                                data-aos="fade-up">Cek Email yang kamu daftarkan dan temukan kode OTP untuk melakukan
                                verifikasi</p>
                        </div>
                    </div>
                    <div class="col-12 col-lg-4">
                        <div data-aos="fade-up">
                            <img src="awan/images/riot-14.png" alt="potensi-pasar-penjualan-produk-digital"
                                style="width: 300px;" data-aos="fade-up" class="img-fluid mx-auto d-block">
                            <p style="height: 100px;" class="font-size-16 mt-3 text-light text-center"
                                data-aos="fade-up">Email berhasil di verifikasi</p>
                        </div>
                    </div>
                    <div class="col-12 col-lg-4">
                        <div data-aos="fade-up">
                            <img src="awan/images/riot-15.png" alt="potensi-pasar-penjualan-produk-digital"
                                style="width: 300px;" data-aos="fade-up" class="img-fluid mx-auto d-block">
                            <p style="height: 100px;" class="font-size-16 mt-3 text-light text-center"
                                data-aos="fade-up">Silahkan Login Ulang untuk bisa mulai melakukan transaksi. Selamat
                                ya!</p>
                        </div>
                    </div>
                </div>

                <div class="row align-items-center">
                    <div class="col-lg-12 col-12">
                        <div class="mt-4 mt-md-auto text-center">
                            <p class="font-size-20 text-light" data-aos="fade-up">Saldo gratis sebesar Rp.50.000 akan masuk otomatis ke akun kamu setelah dilakukan verifikasi oleh Team Awanbisnis <u>maksimal 1X24 Jam</u></p>
                        </div>
                    </div>
                </div>

                <a href="https://wa.me/6281529430000">
                    <div data-aos="fade-right">
                        <img src="awan/images/helpdesk-1.webp" alt="butuh-bantuan-helpdesk-awan-siap-membantu"
                            class="img-fluid mx-auto d-block">
                    </div>
                </a>
            </div>
        </section>
    </div>
</template>
<script>
export default {
    name: 'RiotBali',
    components: {
    },
    data() {
        return {
            items: [
                "Download Aplikasi Awanbisnis",
                "Review di Playstore dan Appstore",
                "Berikan Bintang 5",
                "Follow IG @awanbisnis",
                "Share info tentang Awanbisnis ke orang-orang yang kamu kenal"
            ]
        }
    },
    methods: {
    },
    mounted() {
        // title
        document.title = 'Anniversary 8th Riot Bali'
        this.$Progress.start()
        AOS.init({
            easing: 'ease-out-back',
            duration: 2000,
        });
        this.$Progress.finish()
    },
}
</script>

